import './style.css';
import { el } from './lib/dom.js';
import { toast } from './lib/toast.js';
import { APP_VERSION } from './config/version.js';
import { carregarSessao, sessao, ehGestor, checarVersao, gravarVersaoNuvem } from './lib/auth.js';
import { iniciarRouter, ir } from './lib/router.js';
import { montarLayout, desmontarLayout } from './ui/layout.js';
import { esconderSplash } from './ui/splash.js';
import { carregarOperador, operadorAtual, definirOperadorLogin } from './lib/operador.js';
import { carregarPermissoes, podeAcessar, ehGestorAtivo, rotaInicial, secaoDaRota } from './lib/permissoes.js';
import { carregarTelemetria, registrarTela } from './lib/uso.js';
import { paginaConfiguracoes } from './pages/configuracoes.js';
import { mostrarFeedbacksRecusa } from './ui/feedbackRecusa.js';

import { paginaLogin } from './pages/login.js';
import { paginaDashboard } from './pages/dashboard.js';
import { paginaMovimentacao } from './pages/movimentacao.js';
import { paginaPesquisa } from './pages/pesquisa.js';
import { paginaChaves } from './pages/chaves.js';
import { paginaColaboradores } from './pages/colaboradores.js';
import { paginaEmpregadores } from './pages/empregadores.js';
import { paginaSetores } from './pages/setores.js';
import { paginaCracha } from './pages/cracha.js';
import { paginaVisitaAdministrativa } from './pages/visitaAdministrativa.js';
import { paginaUsuarios } from './pages/usuarios.js';
import { paginaRelatorios } from './pages/relatorios.js';
import { paginaVisitaMotivos, paginaVisitaEmpresas } from './pages/visitaListas.js';

const ROTAS = {
  '/dashboard': { pagina: paginaDashboard },
  '/movimentacao': { pagina: paginaMovimentacao },
  '/cracha': { pagina: paginaCracha },
  '/visita-administrativa': { pagina: paginaVisitaAdministrativa },
  '/setores': { pagina: paginaSetores },
  '/pesquisa': { pagina: paginaPesquisa },
  '/chaves': { pagina: paginaChaves },
  '/colaboradores': { pagina: paginaColaboradores },
  '/empregadores': { pagina: paginaEmpregadores },
  '/usuarios': { pagina: paginaUsuarios, gestor: true },
  '/relatorios': { pagina: paginaRelatorios, gestor: true },
  '/visita-motivos': { pagina: paginaVisitaMotivos },
  '/visita-empresas': { pagina: paginaVisitaEmpresas },
  '/configuracoes': { pagina: paginaConfiguracoes, gestor: true },
};

const login = paginaLogin(async () => { await definirOperadorLogin(); await carregarPermissoes(); ir(rotaInicial() || '/movimentacao'); mostrarFeedbacksRecusa(); });
const paginaSemAcesso = { render(c) { c.innerHTML = ''; c.append(el('div', { class: 'mov-aviso' }, [el('p', { text: 'Seu perfil ainda não tem um módulo ativo. Fale com o gestor.' })])); } };

function resolverAcesso(caminho) {
  if (!sessao.usuario) { desmontarLayout(); return login; }
  const destino = rotaInicial() || '/movimentacao';
  if (caminho === '/' || caminho === '/login') { ir(destino); return null; }
  const rota = ROTAS[caminho];
  if (!rota) { ir(destino); return null; }
  if (rota.gestor && !ehGestorAtivo()) { toast('Acesso restrito ao gestor.', 'erro'); ir(destino); return null; }
  const secao = secaoDaRota(caminho);
  if (secao && !podeAcessar(secao)) {
    const r = rotaInicial();
    if (r && r !== caminho) { ir(r); return null; }
    montarLayout();
    return paginaSemAcesso;
  }
  montarLayout();
  registrarTela(caminho);
  return rota.pagina;
}

async function boot() {
  await carregarSessao();
  carregarOperador();
  if (sessao.usuario) { if (!operadorAtual.nome) await definirOperadorLogin(); await carregarPermissoes(); await verificarVersao(); }
  carregarTelemetria();
  esconderSplash();
  iniciarRouter(resolverAcesso);
}

async function verificarVersao() {
  const { versaoNuvem } = await checarVersao();
  if (!versaoNuvem) { if (ehGestor()) await gravarVersaoNuvem(); return; }
  const cmp = compararVersao(APP_VERSION, versaoNuvem);
  if (cmp < 0) mostrarAvisoVersao(versaoNuvem);
  else if (cmp > 0 && ehGestor()) { await gravarVersaoNuvem(); toast(`Versão do sistema atualizada para ${APP_VERSION}.`, 'sucesso'); }
}

function mostrarAvisoVersao(versaoNuvem) {
  document.body.append(
    el('div', { class: 'aviso-versao' }, [
      el('div', { class: 'aviso-versao__card' }, [
        el('i', { class: 'ph ph-warning' }),
        el('h3', { text: 'Nova versão disponível' }),
        el('p', { class: 'view__sub', text: `Sua versão (${APP_VERSION}) está desatualizada (nuvem: ${versaoNuvem}). Recarregue para continuar.` }),
        el('button', { class: 'btn btn--primario', onClick: () => location.reload() }, 'Recarregar agora'),
      ]),
    ]),
  );
}

function compararVersao(a, b) {
  const pa = String(a).split('.').map(Number);
  const pb = String(b).split('.').map(Number);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] || 0) - (pb[i] || 0);
    if (d !== 0) return d > 0 ? 1 : -1;
  }
  return 0;
}

boot();


















